/* eslint-disable no-unused-vars */
import React from 'react'
import { TbCalendarOff, TbCalendarTime, TbFileDescription, TbPencil, TbPlaylistAdd } from 'react-icons/tb'
import { useToast } from '../../../context/toast-context'
import { Box, Button, Col, Dialog, FabButton, Flex, Gap, Icon, InputField, Row, Typography } from '../../../ppui'
import { formatToDDMMYYYY } from '../../../utils/common'
import { Card, CardHeading, ContentHeading, OrganizationBx, OrganizationEmDetails } from '../../style'
import { EXIT_FORMALITY_FIELDS } from './exit-formality-constant'

const ExitFormalityView = ({
    getInputFieldPropsFn,
    handleSubmit,
    createFormUpdateLoading,
    exitFormalityInput,
    setExitFormalityInput,
    resource,
    exitFormalityModal,
    exitFormalityModalOpen,
    exitFormalityModalClose,
    handleClickOpen,
    imployeeInfoFromDB
}) => {
    const getMinSettlementDate = () => {
        if (!exitFormalityInput.exit_date) return '';
        return new Date(exitFormalityInput.exit_date).toISOString().split('T')[0];
    };

    const today = imployeeInfoFromDB?.join_date ? new Date(imployeeInfoFromDB?.join_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
    const todayDate = new Date().toISOString().split('T')[0];

    const { showToastMessage } = useToast();
    if (!resource) {
        throw new Promise(() => { })
    }
    const ExitFormalityRes = resource.read();
    const exitFormalityInfo = ExitFormalityRes?.data?.data
    return (
        <>
            {exitFormalityInfo?.exit_formality_id ?
                <> 
                <Card>
                    <CardHeading Divider>
                    Exit Formalities
                    <Button
                        onClick={() => handleClickOpen()}
                        icon={<TbPlaylistAdd />}
                        color="primary"
                        size="sm"
                        variant="contained"
                    >
                        Add
                    </Button>
                    </CardHeading>
        
                
                    <OrganizationEmDetails>
                        <OrganizationBx>
                            <Icon size={"lg"}>
                            <TbCalendarOff /> {/* Suitable for Exit Date */}
                            </Icon>
                            <Box>
                            <Typography variant="body1" mb={"0"} color="primary">
                                Exit Date
                            </Typography>
                            <Typography 
                                variant="body2"
                                mb={"0"}
                                color="dark"
                                colorVariant="light"
                                textCase="capitalize">
                                {exitFormalityInfo?.exit_date
                                ? formatToDDMMYYYY(new Date(exitFormalityInfo?.exit_date))
                                : "N/A"}
                            </Typography>
                            </Box>
                        </OrganizationBx>

                        <OrganizationBx>
                            <Icon size={"lg"}>
                            <TbCalendarTime /> {/* Suitable for Settlement Date */}
                            </Icon>
                            <Box>
                            <Typography  variant="body1" mb={"0"} color="primary">
                                Settlement Date
                            </Typography>
                            <Typography
                                variant="body2"
                                mb={"0"}
                                color="dark"
                                colorVariant="light"
                                textCase="capitalize"
                            >
                                {exitFormalityInfo?.settlement_date
                                ? formatToDDMMYYYY(new Date(exitFormalityInfo?.settlement_date))
                                : "N/A"}
                            </Typography>
                            </Box>
                        </OrganizationBx>

                        <OrganizationBx>
                            <Icon size={"lg"}>
                            <TbFileDescription /> {/* Suitable for Exit Reason */}
                            </Icon>
                            <Box>
                            <Typography  variant="body1" mb={"0"} color="primary">
                                Exit Reason
                            </Typography>
                            <Typography
                                variant="body2"
                                mb={"0"}
                                color="dark"
                                colorVariant="light"
                                textCase="capitalize"
                            >
                                {exitFormalityInfo?.reason_for_exit || "N/A"}
                            </Typography>
                            </Box>
                        </OrganizationBx>
                        </OrganizationEmDetails>


                </Card>    
               
                </>
                :
                <>
                    <ContentHeading mb={20}>
                        <Typography variant="h5" mb="0">
                            Exit Formalities
                        </Typography>
                    </ContentHeading>
                    <Row mb={20} alignItem={"center"}>
                        <Col sm={12} md={4}>
                            <InputField
                                {...getInputFieldPropsFn(EXIT_FORMALITY_FIELDS.exit_date.name)}
                                valueSinc
                                onKeyDown={e => e.preventDefault()}
                                min={today}
                            />
                        </Col>
                        <Col sm={12} md={4}>
                            <InputField
                                {...getInputFieldPropsFn(EXIT_FORMALITY_FIELDS.reason_for_exit.name)}
                            />
                        </Col>

                        <Col sm={12} md={4}>
                            <InputField
                                {...getInputFieldPropsFn(EXIT_FORMALITY_FIELDS.settlement_date.name)}
                                valueSinc
                                onKeyDown={e => e.preventDefault()}
                                // min={new Date(exitFormalityInput.exit_date)}
                                // min={getMinSettlementDate()}
                                min={today}
                            />
                        </Col>
                    </Row>
                    <Gap height={100} />
                    <Flex justifyContent="flex-end" gap={"10"}>
                        <Button color="primary" variant="outlined">
                            Cancel
                        </Button>

                        <Button color="primary" variant="contained" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Flex>
                </>
            }
            <Dialog
                title="Employee Exit Formalities
"
                closeButton={true}
                fullWidth
                maxWidth="xs"
                open={exitFormalityModal}
                onClose={exitFormalityModalClose}
                onSubmit={handleSubmit}
                btnLoading={createFormUpdateLoading}
                // buttonName={employeeProfileInput?.employee_id?"Update":"Submit"}
                buttonName={"Update"}
            >
                <Row mb={20} alignItem={"center"} rowGap>
                    <Col sm={12}>
                        <InputField
                            {...getInputFieldPropsFn(EXIT_FORMALITY_FIELDS.exit_date.name)}
                            valueSinc
                            onKeyDown={e => e.preventDefault()}
                            min={today}
                        />
                    </Col>

                    <Col sm={12}>
                        <InputField
                            {...getInputFieldPropsFn(EXIT_FORMALITY_FIELDS.reason_for_exit.name)}
                        />
                    </Col>

                    <Col sm={12}>
                        <InputField
                            {...getInputFieldPropsFn(EXIT_FORMALITY_FIELDS.settlement_date.name)}
                            valueSinc
                            onKeyDown={e => e.preventDefault()}
                            min={getMinSettlementDate()}
                        />
                    </Col>
                </Row>
            </Dialog>
        </>

    )
}

export default ExitFormalityView